import { updatePriceSettingsFromVisibilityOption } from '../../utils/pricing';
import { adjustBroadcastDatesForCrossingMidnight } from '../../utils/date';
import { forceBrowserDownload } from '../../utils/download';

const MAX_IMPORT_RECORDS = 1000;

export default class BulkImportController {
  constructor($timeout, $rootScope, $http, EditOrCreateEventService, Facebook, toaster) {
    'ngInject';

    const { ApiConfig } = $rootScope;

    this.$timeout = $timeout;
    this.$http = $http;
    this.toaster = toaster;
    this.service = EditOrCreateEventService.getInstance();
    this.service.initBroadcast();
    this.service.bulkImportMode = true;
    this.fb = Facebook;
    this.fb.init();
    this.validSports = ApiConfig.stream.sports.map((s) => s.value);
  }

  loginFacebook() {
    this.fb.login();
  }

  logoutFacebook() {
    this.fb.logout().then(() => this.fb.init());
  }

  downloadTemplate() {
    const { $http } = this;

    this.downloadingTemplate = true;
    $http
      .get(`${API_ROOT}/account/broadcast_import_template`, { responseType: 'arraybuffer' })
      .then((response) => {
        this.downloadingTemplate = false;
        console.log('loaded template', response);
        var blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        forceBrowserDownload(URL.createObjectURL(blob), 'broadcast_import.xlsx');
      })
      .catch((data, status) => {
        this.downloadingTemplate = false;
        console.error('Error loading template', data, status);
        alert(
          'Unable to download template. Please refresh your browser and try again. For best results, try using Google Chrome.'
        );
      });
  }

  uploadThumbnail(index) {
    var file = this.thumbnails[index];
    var broadcast = this.broadcasts[index];
    file.upload().then((result) => {
      broadcast.content_settings = broadcast.content_settings || {};
      broadcast.content_settings.preview = result.view_url;
      broadcast.content_settings.poster = result.view_url;
    });
  }

  uploadCSV(result) {
    const { $timeout } = this;

    this.errors = [];
    this.broadcasts = [];
    this.progress = {
      upload: 'todo',
      process: 'todo',
      validate: 'todo',
    };
    this.showProgress = true;
    this.showErrors = false;
    this.showConfirm = false;

    var r = new FileReader();
    r.onload = (e) => {
      $timeout(() => {
        this.progress.upload = 'complete';
        this.parseFile(e.target.result);
      }, 100);
    };
    r.oneror = (e) => {
      $timeout(() => {
        this.progress.upload = 'error';
      }, 0);
    };
    r.readAsText(result.file);
  }

  parseFile(fileContents) {
    const { $timeout } = this;

    this.fileContents = fileContents;
    this.rows = CSVToListOfDicts(this.fileContents);

    this.errors = [];
    this.broadcasts = [];
    this.thumbnails = {};
    this.showTeams = false;
    this.rows.forEach((r, i) => {
      try {
        this.broadcasts.push(this.validateAndTransform(r));
      } catch (e) {
        this.errors.push({ row: r, rowIndex: i, error: e.toString() });
      }
    });

    if (this.broadcasts.length > MAX_IMPORT_RECORDS) {
      this.errors.push({
        row: {},
        rowIndex: MAX_IMPORT_RECORDS,
        error: `A maximum of ${MAX_IMPORT_RECORDS} imported broadcasts are supported. Please remove some from your import file and try again.`,
      });
    }

    // Artificial delays to make it look like we're working hard
    $timeout(() => (this.progress.process = 'complete'), 1000);
    $timeout(() => {
      if (this.errors.length) {
        this.progress.validate = 'error';
        $timeout(() => {
          this.showErrors = true;
          this.showProgress = false;
        }, 1000);
      } else {
        this.progress.validate = 'complete';
        $timeout(() => {
          this.showConfirm = true;
          this.showProgress = false;
        }, 1000);
      }
    }, 2500);
  }

  validateAndTransform(r) {
    var b = {
      id: Math.random(), //<-- required for ng-repeat unique key
      content_settings: {},
      simulcast_configurations: [],
      do_not_record: this.service.account.feature_flags.no_recordings,
    };
    this.service.broadcast = b; //<-- later methods have mutations that occur here

    // Map CSV field names to broadcast fields
    b.name = r.Name;
    if (!b.name) throw 'Name is required';
    b.description = r.Description;

    // Date/Time handling (note the actual saving process does more validation)
    b.startDate = this.service.startDate = moment(r['Date']).toDate();
    if (!r['Date'] || !b.startDate || isNaN(b.startDate.getTime()))
      throw `A valid, future start date is required. Please verify the date format in your CSV file.`;
    b.startTime = this.service.startTime = parseTime(r['Start Time']);
    if (!b.startTime) throw `Invalid start time ${startTime}`;
    b.endTime = this.service.endTime = parseTime(r['End Time']);
    if (!b.endTime) throw `Invalid end time ${endTime}`;
    var dates = adjustBroadcastDatesForCrossingMidnight(
      b.startDate,
      b.startTime,
      b.endTime,
      this.service.maxBroadcastDurationHours
    );
    b.starts_at = dates.starts_at;
    b.stops_at = dates.stops_at;
    if (moment(b.starts_at).toDate() < new Date()) {
      throw `A valid, future start date and time is required`;
    }
    if (!this.service.isWithinAccountBroadcastDurationLimit) {
      throw `You are not allowed to stream for longer than ${this.service.maxBroadcastDurationHours} hours`;
    }

    // Source handling (note that the actual saving process sets stream_source, etc)
    var s = r['Source'];
    var box = _.find(this.service.boxcasters, { name: s });
    var srtSource = _.find(this.service.srtSources, { name: s });
    var staticRtmp = _.find(this.service.staticRTMPs, { name: s });
    if (s == 'BoxCast Broadcaster (iOS)') {
      b.boxcaster_id = 'stream_source:app';
    } else if (box != null) {
      b.boxcaster_id = box.id;
      b.boxcaster_name = box.name;
    } else if (srtSource != null) {
      b.boxcaster_id = `stream_source:srt:${srtSource.id}`;
    } else if (staticRtmp != null) {
      b.boxcaster_id = `stream_source:rtmp:${staticRtmp.id}`;
    } else if (s.startsWith('Producer')) {
      b.boxcaster_id = 'stream_source:producer';
    } else {
      throw `Source ${s} not found`;
    }
    this.service.explodeStreamSourceSettings(b);

    // Accessibility and Ticketing
    var t = r['Broadcast Type'];
    b.visibility = {
      'Private/Test': 'private',
      Public: 'public',
      'Flex (Ticketed HD)': 'flex',
      Ticketed: 'ticketed',
    }[t];
    if (!b.visibility) throw `Broadcast type ${t} invalid`;
    b.ticket_price = parseFloat((r['Ticket Price'] || '').replace('$', ''), 10);
    if (b.visibility == 'ticketed' || b.visibility == 'flex') {
      if (isNaN(b.ticket_price) || b.ticket_price < this.service.minTicketPrice) {
        throw `Minimum ticket price is \$${this.service.minTicketPrice}`;
      }
    } else if (b.ticket_price) {
      throw `A ticket price should not be set on non-ticketed broadcasts`;
    }
    updatePriceSettingsFromVisibilityOption(b, b.visibility);

    // Channel handling
    var c = r['Channels'];
    if (c) {
      var channel = _.find(this.service.channels, { name: c });
      if (!channel) throw `Channel ${c} not found`;
      b.in_channel_ids = [channel.id];
      b.__channel_name__ = channel.name; //for display purposes on confirm screen
    }

    // Advanced Settings
    b.target_video_resolution = 'default';
    if (r['Video Resolution']) {
      b.target_video_resolution = parseInt(r['Video Resolution'], 10);
      if (!_.find(this.service.videoResolutions, { value: b.target_video_resolution })) {
        throw `Invalid video resolution ${this.b.target_video_resolution}`;
      }
    }
    b.target_high_frame_rate = 'default';
    if ((r['High Frame Rate'] || '').toUpperCase() == 'YES') {
      b.target_high_frame_rate = true;
    } else if ((r['High Frame Rate'] || '').toUpperCase() == 'NO') {
      b.target_high_frame_rate = false;
    }
    if (
      this.service.account.feature_flags.automated_captioning ||
      this.service.account.feature_flags.live_automated_captioning
    ) {
      b.requests_captioning = this.service.account.content_settings.requestsCaptioning;
    }

    // Scoreboard
    if (r['Sport']) {
      if (this.validSports.includes(r['Sport'])) {
        b.sport = r['Sport'];
      } else {
        throw `${r['Sport']} is an invalid sport option`;
      }
    }

    if (r['Scoreboard']) {
      this.service.scoreboards.forEach((s) => {
        if (r['Scoreboard'].startsWith(s.value)) {
          b.scoreboard_make = s.value;
          s.models.forEach((m) => {
            if (r['Scoreboard'].endsWith(m.value)) {
              b.scoreboard_model = m.value;
            }
          });
        }
      });
      if (!b.scoreboard_make || !b.scoreboard_model) {
        throw `Invalid scoreboard ${r['Scoreboard']}`;
      }
    }
    b.overlay_location = (r['Scoreboard Location'] || '').toLowerCase();
    b.sportzcast_bot_number = r['SportzCast ScoreBOT Number'];
    b.home_team_name = r['Home Team Name'];
    if (b.home_team_name) {
      b.home_team_logo = this.service.accountScoreboard.home_team_logo;
    }
    b.away_team_name = r['Away Team Name'];

    // Expose home/away color picker if *any* record has a team name defined
    if (b.scoreboard_make || b.home_team_name || b.away_team_name) {
      this.showTeams = true;
    }

    return b;
  }

  addSimulcastDestination(d) {
    return this.service.addSimulcastDestination(d);
  }

  removeSimulcastDestination(d) {
    return this.service.removeSimulcastDestination(d);
  }

  saveAll() {
    this.showSaveProgress = true;
    this.showConfirm = false;

    this.__sharedSimulcastConfigurations = angular.copy(
      this.service.broadcast.simulcast_configurations || []
    );

    this.submittingIndex = 0;

    try {
      this.workSaveQueue();
    } catch (e) {
      console.error(e);
      this.toaster.pop(
        'warning',
        'There was an error saving the broadcast. Please refresh and try again after verifying which broadcasts were created.'
      );
    }
  }

  workSaveQueue(i) {
    if (this.submittingIndex >= this.broadcasts.length) {
      this.showSaveProgress = false;
      this.showComplete = true;
      console.log('Completed all save operations');
      return;
    }

    var b = angular.copy(this.broadcasts[this.submittingIndex]);
    b.simulcast_configurations = this.__sharedSimulcastConfigurations;
    console.log('Saving', b);

    this.service.broadcast = b;

    // Derived value things
    this.service.visibility = b.visibility;
    this.service.startDate = b.startDate;
    this.service.startTime = b.startTime;
    this.service.endTime = b.endTime;
    this.service.compensateEndDate();
    if (this.service.showAnyScoreboards) {
      this.service.broadcast.scoreboard_configuration = {
        sport: b.sport,
        scoreboard_make: b.scoreboard_make,
        scoreboard_model: b.scoreboard_model,
        overlay_location: b.overlay_location,
        home_team_name: b.home_team_name,
        home_team_logo: b.home_team_logo,
        away_team_name: b.away_team_name,
        away_team_logo: b.away_team_logo,
        sportzcast_bot_number: b.sportzcast_bot_number,
      };
    }

    delete b.id;

    this.service
      .saveChanges(true, true)
      .then(() => {
        console.log('Saved!');
        this.submittingIndex++;
        this.workSaveQueue();
      })
      .catch((e) => {
        console.error('Error saving', e);
        this.submittingIndex++;
        this.workSaveQueue();
      });
  }
}

function CSVToListOfDicts(data) {
  var result = [];
  var arr = CSVToArray(data);
  if (arr.length < 2) {
    return result;
  }
  var keyIndex = arr[0];
  for (var i = 1; i < arr.length; i++) {
    if (!_.filter(arr[i]).length) {
      continue;
    }
    var row = {};
    arr[i].forEach((v, j) => {
      row[keyIndex[j]] = v;
    });
    result.push(row);
  }
  return result;
}

// ref: http://stackoverflow.com/a/1293163/2343
// This will parse a delimited string into an array of arrays.
function CSVToArray(data) {
  const delimiter = ',';

  const reQuotedValue = new RegExp('""', 'g');
  const rePattern = new RegExp(
    // Delimiters.
    '(\\' +
      delimiter +
      '|\\r?\\n|\\r|^)' +
      // Quoted fields.
      '(?:"([^"]*(?:""[^"]*)*)"|' +
      // Standard fields.
      '([^"\\' +
      delimiter +
      '\\r\\n]*))',
    'gi'
  );

  // Create an array to hold our data. Give the array
  // a default empty first row.
  var arrData = [[]];

  // Create an array to hold our individual pattern
  // matching groups.
  var arrMatches = null;

  // Keep looping over the regular expression matches
  // until we can no longer find a match.
  while ((arrMatches = rePattern.exec(data))) {
    // Get the delimiter that was found.
    var matchedDelimiter = arrMatches[1];

    // Check to see if the given delimiter has a length
    // (is not the start of string) and if it matches
    // field delimiter. If id does not, then we know
    // that this delimiter is a row delimiter.
    if (matchedDelimiter.length && matchedDelimiter !== delimiter) {
      // Since we have reached a new row of data,
      // add an empty row to our data array.
      arrData.push([]);
    }

    var matchedValue;

    // Now that we have our delimiter out of the way,
    // let's check to see which kind of value we
    // captured (quoted or unquoted).
    if (arrMatches[2]) {
      // We found a quoted value. When we capture
      // this value, unescape any double quotes.
      matchedValue = arrMatches[2].replace(reQuotedValue, '"');
    } else {
      // We found a non-quoted value.
      matchedValue = arrMatches[3];
    }

    // Now that we have our value string, let's add
    // it to the data array.
    arrData[arrData.length - 1].push(matchedValue);
  }

  // Return the parsed data.
  return arrData;
}

function parseTime(timeStr, dt) {
  if (!dt) {
    dt = new Date();
  }

  var time = timeStr.match(/(\d+)(?::(\d\d))?\s*(p?)/i);
  if (!time) {
    return NaN;
  }
  var hours = parseInt(time[1], 10);
  if (hours == 12 && !time[3]) {
    hours = 0;
  } else {
    hours += hours < 12 && time[3] ? 12 : 0;
  }

  dt.setHours(hours);
  dt.setMinutes(parseInt(time[2], 10) || 0);
  dt.setSeconds(0, 0);
  return dt;
}



// WEBPACK FOOTER //
// ./app/pages/bulk-import/bulk-import-controller.js